import React, { FC, memo } from "react";

import { LayersContainerWrapper } from "./styled";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { LayerListModule } from "../../LayerList/LayerList";
import { isVisibleContainer } from "../utils/isVisibleContainer";
import { useWidgetContext } from "../../Dashboard/hooks/useWidgetContext";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";
import { ContainerProps } from "../types";

export const LayersContainer: FC<ContainerProps> = memo(({ type, elementConfig, renderElement }) => {
  const { expandedContainers } = useWidgetContext(type);
  const { isPresentationMode } = usePresentationMode();

  const { id, options, style } = elementConfig || {};
  const { layerNames, expandable, expanded } = options || {};
  const isVisible = isVisibleContainer(id, expandable, expanded, expandedContainers);

  return (
    <>
      <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
      {isVisible && (
        <LayersContainerWrapper style={style} isPresentationMode={isPresentationMode}>
          <LayerListModule layerNames={layerNames} noDrag noSearch noGroups noMenu />
        </LayersContainerWrapper>
      )}
    </>
  );
});
